import { createFileRoute } from '@tanstack/react-router';
import { IntelligenceSearchSchema } from '@web/modules/intelligence/contract';
import { IntelligencePage } from '@web/modules/intelligence/page/intelligence-page';

export const Route = createFileRoute('/_app/intelligence')({
  validateSearch: (search: Record<string, unknown>) => IntelligenceSearchSchema.parse(search),
  component: IntelligenceRoute,
});

function IntelligenceRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IntelligencePage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
